/**
 * Demo Patch Data
 * Creates sample devices when no saved patch exists
 */

/**
 * Demo template definitions
 * Each entry contains: name, portGroups, manufacturer, version
 */
export const DEMO_TEMPLATES = [
    {
        name: 'Babyface Pro',
        manufacturer: 'RME',
        version: 'FS',
        portGroups: [
            { name: 'Main Out', direction: 'output', type: 'audio', count: 2 },
            { name: 'Headphone', direction: 'output', type: 'audio', count: 2 },
            { name: 'Line In', direction: 'input', type: 'audio', count: 8 },
            { name: 'MIDI', direction: 'input', type: 'midi', count: 1 },
            { name: 'MIDI', direction: 'output', type: 'midi', count: 1 }
        ],
        position: { x: 80, y: 100 }
    },
    {
        name: 'Subsequent 37',
        manufacturer: 'MOOG',
        version: 'CV',
        portGroups: [
            { name: 'Audio', direction: 'output', type: 'audio', count: 2 },
            { name: 'MIDI', direction: 'input', type: 'midi', count: 1 },
            { name: 'CV Pitch', direction: 'input', type: 'cv', count: 1 },
            { name: 'CV Filter', direction: 'input', type: 'cv', count: 1 },
            { name: 'Gate', direction: 'input', type: 'gate', count: 1 },
            { name: 'LFO', direction: 'output', type: 'cv', count: 2 }
        ],
        position: { x: 400, y: 80 }
    },
    {
        name: 'Model 12',
        manufacturer: 'TASCAM',
        version: '',
        portGroups: [
            { name: 'Ch 1-4', direction: 'input', type: 'audio', count: 4 },
            { name: 'Ch 5-8', direction: 'input', type: 'audio', count: 4 },
            { name: 'Main', direction: 'output', type: 'audio', count: 2 },
            { name: 'Aux', direction: 'output', type: 'audio', count: 2 }
        ],
        position: { x: 400, y: 350 }
    }
];

/**
 * Create demo patch by instantiating templates and devices
 * @param {Function} createTemplate - Function to create a template (name, portGroups, manufacturer, version)
 * @param {Function} createInstanceFromTemplate - Function to create an instance (templateId, position)
 */
export function createDemoPatch(createTemplate, createInstanceFromTemplate) {
    for (const demo of DEMO_TEMPLATES) {
        const template = createTemplate(
            demo.name,
            demo.portGroups,
            demo.manufacturer,
            demo.version
        );
        createInstanceFromTemplate(template.id, demo.position);
    }
}
